
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const usePartnerDeals = (partnerId: string) => {
  return useQuery({
    queryKey: ["partner-deals", partnerId],
    queryFn: async () => {
      console.log("🔍 [usePartnerDeals] Fetching deals for partner:", partnerId);
      
      if (!partnerId) {
        console.warn("⚠️ [usePartnerDeals] No partner ID provided");
        return [];
      }
      
      const { data, error } = await supabase
        .from('crm_deals')
        .select(`
          *,
          contact:profiles!crm_deals_contact_id_fkey(
            id,
            first_name, 
            last_name, 
            email,
            internal_owner_id,
            external_owner_id,
            organization_id
          ),
          organization:organizations(name, company_id),
          stage:crm_deal_stages(name, color),
          assigned_staff:crm_staff!crm_deals_assigned_to_staff_id_fkey(first_name, last_name, email),
          assigned_partner:crm_partners!crm_deals_assigned_to_partner_id_fkey(first_name, last_name, email)
        `)
        .or(`assigned_to_partner_id.eq.${partnerId},created_by_partner_id.eq.${partnerId}`)
        .order('created_at', { ascending: false });
      
      if (error) {
        console.error("❌ [usePartnerDeals] Error fetching partner deals:", error);
        throw error;
      }
      
      console.log("✅ [usePartnerDeals] Fetched partner deals:", data);
      console.log(`📊 [usePartnerDeals] Total partner deals: ${data?.length || 0}`);
      
      // Transform the data to ensure it matches the Deal interface
      const transformedData = (data || []).map(deal => ({
        ...deal,
        contact: Array.isArray(deal.contact) ? deal.contact[0] : deal.contact,
        organization: Array.isArray(deal.organization) ? deal.organization[0] : deal.organization,
        stage: Array.isArray(deal.stage) ? deal.stage[0] : deal.stage,
        assigned_staff: Array.isArray(deal.assigned_staff) ? deal.assigned_staff[0] : deal.assigned_staff,
        assigned_partner: Array.isArray(deal.assigned_partner) ? deal.assigned_partner[0] : deal.assigned_partner
      }));
      
      console.log("🔧 [usePartnerDeals] Transformed partner deals:", transformedData);
      return transformedData;
    },
    enabled: !!partnerId,
    staleTime: 10000,
    gcTime: 5 * 60 * 1000,
  });
};
